export default "__VITE_ASSET__DYhhS2iN__"